import { api } from '../core';

type CaseAllegationDeleteResponse = object;

type CaseAllegationDeleteProps = {
  caseId: string;
  allegationDocumentId: string;
};

const caseAllegationDeleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCaseAllegationDelete: builder.query<CaseAllegationDeleteResponse, CaseAllegationDeleteProps>({
      query: ({ caseId, allegationDocumentId }: CaseAllegationDeleteProps) => ({
        url: `case/allegation/delete`,
        method: 'POST',
        body: {
          case_id: caseId,
          allegation_document_id: allegationDocumentId
        }
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getCaseAllegationDelete in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostCaseAllegationDeleteQuery } = caseAllegationDeleteApi;
